import { ValueOf } from 'src/models/types/utility-types';

// src\app\services\chatbot\chatbot.service.ts
export const ChatbotLoadingKeys = {
  Default: 'chatbot-content'
} as const;
